<template>
<div class="changeDetails">
  <div class="announcementTitle" v-if="project.oldInfo">澄清后公告：</div>
  <projectInfo :project="project"/>
  <div class="announcementTitle" v-if="project.oldInfo">原公告：</div>
  <projectInfo :project="project.oldInfo"/>
</div>
</template>

<script>
import {getNormalProjectInfo} from '@api/project'
import projectInfo from '@/components/projectInfo'
export default {
  name: "changeDetails",
  components: {projectInfo},
  data () {
    return {
      project: {},
      projectId: ''
    }
  },
  created() {
    // 获取项目详情
    this.getNormalProjectInfo()
    this.projectId = this.$route.query.id
  },
  methods: {
    // 获取项目详情
    getNormalProjectInfo() {
      getNormalProjectInfo({id: this.$route.query.id}).then(res => {
        if (res.data.code === 200) {
          this.project = res.data.data
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/css/mixin";
.changeDetails{
  margin: 0 0 70px 0;
  padding: 15px 0 15px 0;
  background: #fff;
  .announcementTitle{
    @include add_size($font_size_17);
    margin: 12px;
  }
}
</style>
